import { render, staticRenderFns } from "./UserStatement.vue?vue&type=template&id=442c3878&"
import script from "./UserStatement.vue?vue&type=script&lang=js&"
export * from "./UserStatement.vue?vue&type=script&lang=js&"
import style0 from "./UserStatement.vue?vue&type=style&index=0&id=442c3878&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports